import { AriaAttributes } from "react";

export const concatAriaAttribute = <T extends AriaAttributes>(
    props: T,
    key: keyof T,
    val: string | null,
) => {
    const next = [props[key], val].filter(it => !!it).join(" ");
    return next !== "" ? { [key]: next } : {};
};
